import { render, staticRenderFns } from "./page3.vue?vue&type=template&id=76a3fa6a"
import script from "./page3.vue?vue&type=script&lang=js"
export * from "./page3.vue?vue&type=script&lang=js"
import style0 from "./page3.vue?vue&type=style&index=0&id=76a3fa6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports